<template>
  <v-container container--fluid fill-height class="pa-0">
    <v-card flat class="mx-auto my-12 py-4 px-2" max-width="350">
      <template slot="progress">
        <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
      </template>

      <v-img height="250" contain src="https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-info-mobile.png"></v-img>

      <v-card-title class="pb-3 mt-4 primary--text" style="word-break: normal">Lebih fleksibel diaplikasi <br />Ayo Guru Belajar</v-card-title>

      <v-card-text> Install aplikasi Ayo Guru Belajar dulu yah, agar belajar lebih nyaman </v-card-text>

      <v-card-actions>
        <m-button
          isBlock
          large
          class="mx-1"
          color="primary"
          :small="$vuetify.breakpoint.smAndDown ? true : false"
          textButton="Install Aplikasi Sekarang"
          icon=""
          action="mulai"
          @mulai="triggerAppOpen"
        ></m-button>
      </v-card-actions>
      <div class="text-center pt-8">
        <img src="https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/logo-playstore.png" class="v-responsive__content" style="max-width: 150px" alt="" />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { MOBILE_APP } from "@/const";

export default {
  components: {},
  $_veeValidate: {
    validator: "new",
  },
  data: () => ({
    drawer: true,
    loading: false,
    token: null,
    refresh_token: null,
  }),
  activated() {
    this.$validator.reset();
    this.checkQuery();
  },
  mounted() {
    this.$validator.reset();
    this.checkQuery();
  },
  methods: {
    checkQuery() {
      var url = new URL(window.location.href);
      this.token = url.searchParams.get("access_token");
      this.refresh_token = url.searchParams.get("refresh_token");

      // clean query
      window.history.replaceState({}, document.title, "/#/to-mobile-app");
      // langsung lakukan verifikasi
      this.$nextTick(() => {
        this.triggerAppOpen(this.token, this.refresh_token);
      });
    },
    fallbackToStore() {
      window.location.replace("https://play.google.com/store/apps/details?id=id.simpkb.gurubelajar");
    },
    triggerAppOpen(token, refresh_token) {
      setTimeout(this.fallbackToStore, 1250);
      var url = null;
      if (token && refresh_token) {
        url = MOBILE_APP + "?access_token" + token + "&&refresh_token=" + refresh_token;
      } else {
        url = MOBILE_APP;
      }
      window.location = url;
    },
  },
};
</script>
<style scoped lang="css">
.bg {
  /* The image used */
  background-image: url("https://cdn.siap.id/s3/siap_belajar/sim/bg-login-siap-belajar.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
